import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, setConsent } from '../lib/consent';
import './CookieConsent.css';

function CookieConsent({ onChange }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getConsent());
  }, []);

  function choose(value) {
    setConsent(value);
    setVisible(false);
    onChange?.(value);
  }

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <p>
        Usamos cookies analíticas propias (sin compartir datos con terceros) para entender qué contenido interesa
        más. Puedes aceptarlas o rechazarlas — la web funciona igual en ambos casos.{' '}
        <Link to="/cookies">Más información</Link>.
      </p>
      <div className="cookie-consent__actions">
        <button type="button" className="secondary" onClick={() => choose('rejected')}>Rechazar</button>
        <button type="button" onClick={() => choose('accepted')}>Aceptar</button>
      </div>
    </div>
  );
}

export default CookieConsent;
